export const classes = {
  root: {
    backgroundColor: '#f6f7fb',
    '& tr td div:first-of-type:before': {
      backgroundColor: 'transparent',
    },
    '& tr td:last-child:after': {
      backgroundColor: 'transparent',
    },
  },
};
